import { getNetworkNameFromFQDN, isString } from '../../util-functions';
export var extractVidmHostProperties = function (globalEnvironment, tenantName) {
    var vidmHostname;
    var vidmAdminPassword;
    var vidmVersion;
    var vidmSshPassword;
    var vidmRootPassword;
    var tenancyEnabled = false;
    var vidmOAuthServiceClientId;
    var vidmOAuthServiceClientSecret;
    var vidmProductCertificate;
    var defaultTenantAlias;
    var vidmDomainName;
    var vidmProduct = globalEnvironment.products.find(function (p) { return p.id === 'vidm'; });
    if (vidmProduct) {
        vidmAdminPassword = vidmProduct.properties.vidmAdminPassword;
        vidmProductCertificate = vidmProduct.properties.certificate;
        vidmVersion = vidmProduct.version;
        tenancyEnabled = vidmProduct.properties.__isTenancyEnabled === 'true';
        vidmOAuthServiceClientId = vidmProduct.properties.vidmOAuthServiceClientId;
        vidmOAuthServiceClientSecret =
            vidmProduct.properties.vidmOAuthServiceClientSecret;
        defaultTenantAlias = vidmProduct.properties.defaultTenantAlias;
        vidmDomainName = vidmProduct.properties.vidmDomainName;
        vidmHostname = defaultTenantAlias;
        if (!vidmHostname &&
            vidmProduct.properties &&
            vidmProduct.properties.isClustered === 'true') {
            if (vidmProduct.clusterVIP && vidmProduct.clusterVIP.clusterVips) {
                var lbNode = vidmProduct.clusterVIP.clusterVips.find(function (c) { return c.type === 'vidm-lb'; });
                if (lbNode && lbNode.properties && lbNode.properties.hostName) {
                    vidmHostname = lbNode.properties.hostName;
                }
            }
        }
        var primaryNode = vidmProduct.nodes.find(function (n) { return n.type === 'vidm-primary'; });
        if (primaryNode) {
            if (!vidmHostname) {
                vidmHostname = primaryNode.properties.hostName;
            }
            if (!vidmSshPassword) {
                vidmSshPassword = primaryNode.properties.vidmSshPassword;
            }
            if (!vidmRootPassword) {
                vidmRootPassword = primaryNode.properties.vidmRootPassword;
            }
        }
    }
    return {
        vidmHostname: vidmHostname && tenantName
            ? tenantName + "." + (vidmDomainName
                ? vidmDomainName
                : getNetworkNameFromFQDN(vidmHostname))
            : vidmHostname,
        vidmAdminPassword: vidmAdminPassword,
        vidmAdminUser: 'admin',
        baseTenantHostname: defaultTenantAlias,
        vidmDomainName: vidmDomainName,
        vidmVersion: vidmVersion,
        vidmSshPassword: vidmSshPassword,
        vidmRootPassword: vidmRootPassword,
        tenancyEnabled: tenancyEnabled,
        vidmOAuthServiceClientId: vidmOAuthServiceClientId,
        vidmOAuthServiceClientSecret: vidmOAuthServiceClientSecret,
        vidmProductCertificate: vidmProductCertificate,
        clusteredVidm: !!vidmProduct && vidmProduct.nodes.some(function (n) { return n.type === 'vidm-secondary'; })
    };
};
export var isVidmTaskJobSuccessful = function (taskResponse) {
    return taskResponse ? taskResponse.status === 'SUCCESS' : false;
};
export function extractVidmTaskSuccessData(taskResponse) {
    return taskResponse && isVidmTaskJobSuccessful(taskResponse)
        ? taskResponse.response
        : undefined;
}
export function extractVidmTaskErrors(taskResponse) {
    return taskResponse && taskResponse.status === 'FAILED'
        ? parseVidmTaskAPIErrors(taskResponse)
        : undefined;
}
export function parseVidmTaskAPIErrors(taskResponse) {
    if (taskResponse && taskResponse.response) {
        var parsedReponse = taskResponse.response;
        if (parsedReponse) {
            if (parsedReponse.errors && Array.isArray(parsedReponse.errors)) {
                return parsedReponse.errors.map(function (e) {
                    return isString(e) ? e : JSON.stringify(e);
                });
            }
            if (Array.isArray(parsedReponse)) {
                return parsedReponse.map(function (pr) {
                    return isString(pr) ? pr : JSON.stringify(pr);
                });
            }
            return [
                isString(parsedReponse) ? parsedReponse : JSON.stringify(parsedReponse)
            ];
        }
    }
}
export var vidmDataError = function (err) {
    return "Something went wrong while fetching VMware Identity Manager details.\n  " + (err ? " " + JSON.stringify(err) : '');
};
